import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from './global.service';
import { map, catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { Subject, Observable, BehaviorSubject } from 'rxjs';

const devUrl = environment.backendurl

@Injectable({
  providedIn: 'root'
})
export class TalentpoolService {

  constructor(private http: HttpClient) { }

  public talentpoolcreatedata: Subject<any> = new Subject(); 
 
 //update Talentpool Details
 updateTalentpoolDetails(data){
  var url = devUrl + "/updatetalentpooldetails"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Update Talentpool Details', url)));
}

createTalentpool(data){
  var url = devUrl + "/createtalentpool"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Create Talentpool Details', url)));
}

//Add candidate to Talentpool
addCandidatetoTalentpool(data){ 
  var url = devUrl + "/addcandidatetotalentpool"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Add Candidate to Talentpool', url)));
}

//Remove Bulk candidate from Talentpool
removeCandidatefromTalentpool(data){
  let url = devUrl + '/talentpool/inactivatecandidate'
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Talentpool Candidate', url)))
}

//Get Talentpool List
  getTalentpoolList(usernumber, sortby?:string, nameincludes ?:string): Observable<any> {
    let url = devUrl + "/gettalentpoollist"
    let params = {usernumber: usernumber};
    if (sortby)
       params['sortby'] = sortby
    if(nameincludes)
       params['nameincludes'] = nameincludes
    return this.http.get(url, {params:params}).pipe(
      map(response => { return response; })
    , catchError(GlobalService.handleError('Get Talentpool List', url)));
  }

  /**
   * Get shared talentpools list
   * @param usernumber 
   * @param sortby 
   * @param nameincludes 
   */
  getSharedTalentpoolsList(usernumber: string, sortby?: string, nameincludes?: string): Observable<any> {
    const url = devUrl + "/talentpool/shared", params = { usernumber: usernumber };
    if (sortby) params['sortby'] = sortby
    if(nameincludes) params['nameincludes'] = nameincludes;

    return this.http.get(url, { params }).pipe(
      map(response => { return response; })
    , catchError(GlobalService.handleError('Get Shared Talentpool List', url)));
  }

  /**
   * Get talentpools existing share info 
   * @param payload 
   */
  getExistingShareInfoForTalentpools(payload: { talentpools: (string | number)[] }, onlyActive = true) {
    let url = devUrl + '/talentpool/shared/users';
    return this.http.post(url, payload, { params: !onlyActive ? { all: 'true' } : {} }).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Get Talentpools Users-Shared-With', url)));
  }

  /**
   * Modify access to talentpools (share/unshare talentpools)
   * @param payload 
   */
  shareTalentpools(payload) {
    const url = devUrl + "/talentpool/share";
    return this.http.post(url, payload).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Share Talentpools', url)));
  }

//get Candidate of selected Talentpool
  getTalenpoolCandidate(data){
    let url = devUrl + '/gettalentpoolcandidatedetails'
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Get Talentpool Candidate', url)))
  }

  //deletetalentpool removetalentpool
  RemoveTalentpoolDetails(data){
    let url = devUrl + '/removetalentpool'
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('REmove Talentpool', url)))
  }

  bulkGrabStatus(){
    let url = devUrl + "/searchtoolbox/bulkgrabstatus"
    return this.http.get(url).pipe(
      map(response => { return response; })
    , catchError(GlobalService.handleError('Bulk grab status failed', url)));
  }

  removetalentpoolsinbulk(data) {
    let url = devUrl + "/removetalentpoolsinbulk"
    return this.http.put(url, data).pipe(
      map(response => { return response; })
    , catchError(GlobalService.handleError('Bulk grab status failed', url)));
  }

  bulkRevealStatus(data){
    let url = devUrl + "/talentpool/candidates/bulk-reveal";
    return this.http.post(url, data).pipe(
      map(response => response)
    );
  }


  public createTalentpoolData (): void {
    this.talentpoolcreatedata.next();
  }
  
  public GetCreatedTalentpoolData (): Observable<any> {
    return this.talentpoolcreatedata.asObservable();
  }

  /**
   * Store talent pool details list
   */
  private talentPoolDetailsSubject = new BehaviorSubject<any>({});

  /**
   * Set talent pool details
   * @param data 
   */
  setTalentPoolDetails(data: any) {
    this.talentPoolDetailsSubject.next(data);
  }

  /**
   * Get talent pool details
   */
  get talentPoolDetails(): Observable<any> {
    return this.talentPoolDetailsSubject.asObservable();
  }

  /**
   * Store shared talent pool details
   */
  private sharedTalentPoolDetailsSubject = new BehaviorSubject<any>({});

  /**
   * Set shared talent pool details
   * @param data 
   */
  setSharedTalentPoolDetails(data: any) {
    this.sharedTalentPoolDetailsSubject.next(data);
  }

  /**
   * Get shared talent pool details
   */
  get sharedTalentPoolDetails(): Observable<any> {
    return this.sharedTalentPoolDetailsSubject.asObservable();
  }


  /**
   * Store shared all candidates details
   */
  private allCandidateDetailsSubject = new BehaviorSubject<any>({});

  /**
   * Set shared all candidates details
   * @param data 
   */
  setAllCandidateDetails(data: any) {
    this.allCandidateDetailsSubject.next(data);
  }

  /**
   * Get shared all candidates details
   */
  get allCandidateDetails(): Observable<any> {
    return this.allCandidateDetailsSubject.asObservable();
  }

  /**
   * Store talent pool count list
  */
  private talentPoolCountSubject = new BehaviorSubject<any>({});

  /**
    * Set talent pool count
    * @param data 
  */
  setTalentPoolCount(data: any) {
    this.talentPoolCountSubject.next(data);
  }
  
  /**
    * Get talent pool count
  */
  get talentPoolCount(): Observable<any> {
    return this.talentPoolCountSubject.asObservable();
  }

  /**
   * Bulk Reveal status
   */
  private bulkProsessStatusSubject = new Subject<any>();

  /**
   * set Bulk Reveal status
   */
  setBulkProcessStatus(data: any){
    this.bulkProsessStatusSubject.next(data);
  }

  /**
   * get Bulk Reveal status
   */
  get getBulkProcessStatus(): Observable<any>{
    return this.bulkProsessStatusSubject.asObservable();
  }
}
